import React, {useState, useEffect} from 'react';
import Profile from './Profile';
import Newfeed from './Newfeed';
import Story from './Story';
import Photo from './Photo';
import Video from './Video';
import Movie from './Movie';
import Shop from './Shop';
import Header from './Header';
import AccHeader from './AccHeader';
import FriendProfile from './FriendProfile'
import db from './firebase';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";

function AccPage({userdata}) {
    const [sideopen, setSideopen] = useState(false)
    const menuOpen = () => {
        setSideopen(!sideopen)
    }
    const [messopen, setMessopen] = useState(false)
    const messOpen = () => {
        setMessopen(!messopen)
    }
    const [fromData, setFromData] = useState([])
    useEffect(() => {
        db.collection('users').where('email','==',userdata).
        onSnapshot((snapshot) => setFromData(snapshot.docs.map((doc)=>({
            id:doc.id, data:doc.data()
        }))))
    }, [])
    return (
        <div>
            <Router>
                {
                    fromData.map((fromD) => (
                        <Header 
                            username = {fromD.data.firstName + " " + fromD.data.lastName}
                            firstname = {fromD.data.firstName}
                            profilePic = {fromD.data.profileImage}
                            userId = {fromD.id}
                            menuOpen = {menuOpen}
                            messOpen = {messOpen}
                        />
                    ))
                }
                <Switch>
                <Route path="/account/:searchTerm">
                {
                    fromData.map((fromD) => (
                        <AccHeader 
                            username = {fromD.data.firstName + " " + fromD.data.lastName}
                            firstname = {fromD.data.firstName}
                            profilePic = {fromD.data.profileImage}
                            userId = {fromD.id}
                            menuOpen = {menuOpen}
                            messOpen = {messOpen}
                        />
                    ))
                }
                {
                    fromData.map((fromD) => (
                        <Profile 
                            username = {fromD.data.firstName + " " + fromD.data.lastName}
                            userId = {fromD.id}
                            birthday = {fromD.data.birthday.day}
                            email = {fromD.data.email}
                            password = {fromD.data.password}
                            profilePic = {fromD.data.profileImage}
                            coverPic = {fromD.data.coverImage}
                        />
                    ))
                }
                </Route>
                <Route path="/friend/:searchTerm">
                {
                    fromData.map((fromD) => (
                        <AccHeader 
                            username = {fromD.data.firstName + " " + fromD.data.lastName}
                            firstname = {fromD.data.firstName}
                            profilePic = {fromD.data.profileImage}
                            userId = {fromD.id}
                            menuOpen = {menuOpen}
                            messOpen = {messOpen}
                        />
                    ))
                }
                <FriendProfile />
                </Route>
                <Route path="/story/:searchTerm">
                {
                    fromData.map((fromD) => (
                        <Story 
                            username = {fromD.data.firstName + " " + fromD.data.lastName}
                            userId = {fromD.id}
                            birthday = {fromD.data.birthday.day}
                            email = {fromD.data.email}
                            password = {fromD.data.password}
                            profilePic = {fromD.data.profileImage}
                            menuOpen = {sideopen}
                            messOpen = {messopen}
                            menuopen = {menuOpen}
                        />
                    ))
                }
                </Route>
                <Route path="/photo/:searchTerm">
                {
                    fromData.map((fromD) => (
                        <Photo 
                            username = {fromD.data.firstName + " " + fromD.data.lastName}
                            userId = {fromD.id}
                            birthday = {fromD.data.birthday.day}
                            email = {fromD.data.email}
                            password = {fromD.data.password}
                            profilePic = {fromD.data.profileImage}
                            menuOpen = {sideopen}
                            messOpen = {messopen}
                            menuopen = {menuOpen}
                        />
                    ))
                }
                </Route>
                <Route path="/video/:searchTerm">
                {
                    fromData.map((fromD) => (
                        <Video 
                            username = {fromD.data.firstName + " " + fromD.data.lastName}
                            userId = {fromD.id}
                            birthday = {fromD.data.birthday.day}
                            email = {fromD.data.email}
                            password = {fromD.data.password}
                            profilePic = {fromD.data.profileImage}
                            menuOpen = {sideopen}
                            messOpen = {messopen}
                            menuopen = {menuOpen}
                        />
                    ))
                }
                </Route>
                <Route path="/movie/:searchTerm">
                {
                    fromData.map((fromD) => (
                        <Movie 
                            username = {fromD.data.firstName + " " + fromD.data.lastName}
                            userId = {fromD.id}
                            birthday = {fromD.data.birthday.day}
                            email = {fromD.data.email}
                            password = {fromD.data.password}
                            profilePic = {fromD.data.profileImage}
                            menuOpen = {sideopen}
                            messOpen = {messopen}
                            menuopen = {menuOpen}
                        />
                    ))
                }
                </Route>
                <Route path="/shop/:searchTerm">
                {
                    fromData.map((fromD) => (
                        <Shop 
                            username = {fromD.data.firstName + " " + fromD.data.lastName}
                            userId = {fromD.id}
                            birthday = {fromD.data.birthday.day}
                            email = {fromD.data.email}
                            password = {fromD.data.password}
                            profilePic = {fromD.data.profileImage}
                            menuOpen = {sideopen}
                            messOpen = {messopen}
                            menuopen = {menuOpen}
                        />
                    ))
                }
                </Route>
                <Route path="/">
                {
                    fromData.map((fromD) => (
                        <Newfeed 
                            username = {fromD.data.firstName + " " + fromD.data.lastName}
                            userId = {fromD.id}
                            birthday = {fromD.data.birthday.day}
                            email = {fromD.data.email}
                            password = {fromD.data.password}
                            profilePic = {fromD.data.profileImage}
                            menuOpen = {sideopen}
                            messOpen = {messopen}
                            menuopen = {menuOpen}
                        />
                    ))
                }
                </Route>
                </Switch>
            </Router>
            
        </div>
    )
}

export default AccPage
/*
<Newfeed 
                userId = {fromData.id}
                username = {fromData.data.firstName + " " + fromData.data.lastName}
                birthday = {fromData.data.birthday.day}
                email = {fromData.data.email}
                password = {fromData.data.password}
            />

*/